export enum EditorNodeKind {
  MAP_AND_COLORS = 'MAP_AND_COLORS',
  SPOT = 'SPOT',
}

export enum EditorGroupId {
  ENVIRONMENT = 'ENVIRONMENT',
  SPOTS = 'SPOTS',
  OBJECTS = 'OBJECTS',
  ZONES = 'ZONES',
}

export type EditorGroupStatus = 'available' | 'coming_soon' | 'hidden';

export interface EditorGroupConfig {
  id: EditorGroupId;
  labelKey: string;
  labelFallback: string;
  status: EditorGroupStatus;
  nodeKind?: EditorNodeKind;
}

export const EDITOR_GROUPS: EditorGroupConfig[] = [
  {
    id: EditorGroupId.ENVIRONMENT,
    labelKey: 'editorMode.groupEnvironment',
    labelFallback: 'Environment',
    status: 'available',
    nodeKind: EditorNodeKind.MAP_AND_COLORS,
  },
  {
    id: EditorGroupId.SPOTS,
    labelKey: 'editorMode.groupSpots',
    labelFallback: 'Spots',
    status: 'available',
    nodeKind: EditorNodeKind.SPOT,
  },
  {
    id: EditorGroupId.OBJECTS,
    labelKey: 'editorMode.groupObjects',
    labelFallback: 'Objects',
    status: 'coming_soon',
  },
  {
    id: EditorGroupId.ZONES,
    labelKey: 'editorMode.groupZones',
    labelFallback: 'Zones',
    status: 'coming_soon',
  },
];

export type EditorSelectedNode =
  | { kind: EditorNodeKind.MAP_AND_COLORS }
  | { kind: EditorNodeKind.SPOT; ueIdentifier: string }
  | null;

export type SpotType = 'IMAGE' | 'VIDEO' | 'QR';

export const getSpotType = (spot: unknown): SpotType => {
  const raw =
    typeof (spot as { type?: unknown })?.type === 'string'
      ? ((spot as { type: string }).type as string).toUpperCase()
      : '';
  if (raw === 'VIDEO') {
    return 'VIDEO';
  }
  if (raw === 'QR') {
    return 'QR';
  }

  return 'IMAGE';
};
